import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Calendar, Clock, RefreshCw, Info, Lock, CreditCard } from 'lucide-react';
import { SEOHead } from '../components/SEOHead';
// --- Custom Bespoke SVG Illustrations ---
const RenovationHeaderIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1918">
    <circle cx="32" cy="32" r="30" stroke="#1B1B2F" strokeWidth="2" strokeDasharray="4 4" fill="#E8F6F5" data-id="element-1919" />
    <path d="M22 36 L30 28 L36 34 L28 42 Z" fill="#2BBCB3" data-id="element-1920" />
    <path d="M30 28 L40 18 C42 16 46 16 48 18 C50 20 50 24 48 26 L38 36 Z" fill="#1B1B2F" data-id="element-1921" />
    <circle cx="44" cy="22" r="2" fill="#F5C842" data-id="element-1922" />
    <path d="M22 36 L16 42 C14 44 14 48 16 50 C18 52 22 52 24 50 L30 44" fill="#1B1B2F" data-id="element-1923" />
  </svg>;
const AirbnbComboIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1924">
    <rect x="12" y="28" width="40" height="20" rx="4" fill="#1B1B2F" data-id="element-1925" />
    <rect x="8" y="36" width="8" height="16" rx="2" fill="#2BBCB3" data-id="element-1926" />
    <rect x="48" y="36" width="8" height="16" rx="2" fill="#2BBCB3" data-id="element-1927" />
    <rect x="16" y="20" width="32" height="12" rx="4" fill="#E8F6F5" data-id="element-1928" />
    <path d="M16 32 L48 32" stroke="#F5C842" strokeWidth="2" data-id="element-1929" />
  </svg>;
const DishwasherIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1930">
    <rect x="12" y="12" width="40" height="40" rx="4" fill="#1B1B2F" data-id="element-1931" />
    <rect x="16" y="16" width="32" height="8" rx="2" fill="#2BBCB3" data-id="element-1932" />
    <rect x="16" y="28" width="32" height="20" rx="2" fill="#E8F6F5" data-id="element-1933" />
    <circle cx="24" cy="38" r="6" fill="#F5C842" data-id="element-1934" />
    <circle cx="40" cy="38" r="6" fill="#F5C842" data-id="element-1935" />
    <path d="M16 28 L48 28" stroke="#1B1B2F" strokeWidth="2" data-id="element-1936" />
  </svg>;
const LaundryIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1937">
    <rect x="14" y="10" width="36" height="44" rx="4" fill="#1B1B2F" data-id="element-1938" />
    <rect x="18" y="14" width="28" height="8" rx="2" fill="#2BBCB3" data-id="element-1939" />
    <circle cx="32" cy="36" r="12" fill="#E8F6F5" data-id="element-1940" />
    <circle cx="32" cy="36" r="8" fill="#2BBCB3" fillOpacity="0.3" data-id="element-1941" />
    <circle cx="22" cy="18" r="2" fill="#1B1B2F" data-id="element-1942" />
    <circle cx="28" cy="18" r="2" fill="#1B1B2F" data-id="element-1943" />
  </svg>;
const OvenIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1944">
    <rect x="12" y="14" width="40" height="40" rx="4" fill="#1B1B2F" data-id="element-1945" />
    <rect x="16" y="18" width="32" height="10" rx="2" fill="#2BBCB3" data-id="element-1946" />
    <rect x="16" y="32" width="32" height="18" rx="2" fill="#E8F6F5" data-id="element-1947" />
    <rect x="22" y="36" width="20" height="10" rx="1" fill="#1B1B2F" data-id="element-1948" />
    <circle cx="20" cy="23" r="2" fill="#1B1B2F" data-id="element-1949" />
    <circle cx="28" cy="23" r="2" fill="#1B1B2F" data-id="element-1950" />
    <circle cx="36" cy="23" r="2" fill="#1B1B2F" data-id="element-1951" />
    <circle cx="44" cy="23" r="2" fill="#1B1B2F" data-id="element-1952" />
  </svg>;
const FridgeIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1953">
    <rect x="16" y="8" width="32" height="48" rx="4" fill="#1B1B2F" data-id="element-1954" />
    <rect x="20" y="12" width="24" height="16" rx="2" fill="#2BBCB3" data-id="element-1955" />
    <rect x="20" y="30" width="24" height="22" rx="2" fill="#E8F6F5" data-id="element-1956" />
    <rect x="24" y="16" width="2" height="8" fill="#1B1B2F" data-id="element-1957" />
    <rect x="24" y="34" width="2" height="12" fill="#1B1B2F" data-id="element-1958" />
  </svg>;
const FacadeWindowsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1959">
    <rect x="12" y="12" width="40" height="40" rx="2" fill="#1B1B2F" data-id="element-1960" />
    <rect x="16" y="16" width="14" height="16" fill="#E8F6F5" data-id="element-1961" />
    <rect x="34" y="16" width="14" height="16" fill="#E8F6F5" data-id="element-1962" />
    <rect x="16" y="36" width="14" height="12" fill="#E8F6F5" data-id="element-1963" />
    <rect x="34" y="36" width="14" height="12" fill="#E8F6F5" data-id="element-1964" />
    <path d="M12 34 L52 34" stroke="#2BBCB3" strokeWidth="2" data-id="element-1965" />
    <path d="M32 12 L32 52" stroke="#2BBCB3" strokeWidth="2" data-id="element-1966" />
  </svg>;
const MicrowaveIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1967">
    <rect x="10" y="20" width="44" height="24" rx="4" fill="#1B1B2F" data-id="element-1968" />
    <rect x="14" y="24" width="24" height="16" rx="2" fill="#E8F6F5" data-id="element-1969" />
    <rect x="42" y="24" width="8" height="16" rx="2" fill="#2BBCB3" data-id="element-1970" />
    <rect x="44" y="26" width="4" height="2" fill="#1B1B2F" data-id="element-1971" />
    <rect x="44" y="30" width="4" height="2" fill="#1B1B2F" data-id="element-1972" />
    <rect x="44" y="34" width="4" height="2" fill="#1B1B2F" data-id="element-1973" />
  </svg>;
const CabinetsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1974">
    <rect x="12" y="12" width="40" height="40" rx="2" fill="#1B1B2F" data-id="element-1975" />
    <rect x="14" y="14" width="17" height="36" fill="#2BBCB3" data-id="element-1976" />
    <rect x="33" y="14" width="17" height="36" fill="#2BBCB3" data-id="element-1977" />
    <rect x="27" y="30" width="2" height="8" fill="#1B1B2F" data-id="element-1978" />
    <rect x="35" y="30" width="2" height="8" fill="#1B1B2F" data-id="element-1979" />
  </svg>;
const BasementIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1980">
    <path d="M12 12 L32 12 L32 28 L48 28 L48 44 L52 44 L52 52 L12 52 Z" fill="#1B1B2F" data-id="element-1981" />
    <rect x="16" y="36" width="12" height="12" rx="2" fill="#F5C842" data-id="element-1982" />
    <rect x="36" y="32" width="8" height="8" rx="1" fill="#2BBCB3" data-id="element-1983" />
  </svg>;
const FluBusterIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1984">
    <path d="M32 12 C42 12 50 20 50 32 C50 48 32 56 32 56 C32 56 14 48 14 32 C14 20 22 12 32 12 Z" fill="#2BBCB3" data-id="element-1985" />
    <path d="M32 20 L32 44 M20 32 L44 32" stroke="#FFFFFF" strokeWidth="4" strokeLinecap="round" data-id="element-1986" />
    <circle cx="44" cy="20" r="4" fill="#E85D4A" data-id="element-1987" />
    <circle cx="20" cy="44" r="3" fill="#F5C842" data-id="element-1988" />
  </svg>;
const SheetsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1989">
    <rect x="12" y="24" width="40" height="20" rx="4" fill="#1B1B2F" data-id="element-1990" />
    <rect x="16" y="20" width="14" height="8" rx="2" fill="#F5C842" data-id="element-1991" />
    <rect x="34" y="20" width="14" height="8" rx="2" fill="#F5C842" data-id="element-1992" />
    <path d="M12 34 L52 34 L52 44 L12 44 Z" fill="#2BBCB3" data-id="element-1993" />
    <path d="M12 34 Q32 24 52 34" fill="#E8F6F5" data-id="element-1994" />
    <rect x="16" y="44" width="4" height="6" fill="#1B1B2F" data-id="element-1995" />
    <rect x="44" y="44" width="4" height="6" fill="#1B1B2F" data-id="element-1996" />
  </svg>;
const PropertyCleanupIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1997">
    <path d="M32 12 L12 28 L16 28 L16 48 L48 48 L48 28 L52 28 Z" fill="#1B1B2F" data-id="element-1998" />
    <rect x="28" y="36" width="8" height="12" fill="#E8F6F5" data-id="element-1999" />
    <path d="M40 32 L46 20 L48 22 L42 34 Z" fill="#F5C842" data-id="element-2000" />
    <circle cx="46" cy="20" r="3" fill="#2BBCB3" data-id="element-2001" />
    <path d="M18 48 L26 40 L30 48 Z" fill="#E85D4A" data-id="element-2002" />
  </svg>;
const PatioIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-2003">
    <rect x="12" y="40" width="40" height="8" rx="2" fill="#1B1B2F" data-id="element-2004" />
    <rect x="16" y="24" width="4" height="16" fill="#1B1B2F" data-id="element-2005" />
    <rect x="28" y="24" width="4" height="16" fill="#1B1B2F" data-id="element-2006" />
    <rect x="44" y="24" width="4" height="16" fill="#1B1B2F" data-id="element-2007" />
    <rect x="12" y="20" width="40" height="4" rx="1" fill="#1B1B2F" data-id="element-2008" />
    <circle cx="32" cy="14" r="6" fill="#F5C842" data-id="element-2009" />
    <path d="M26 14 Q32 8 38 14" stroke="#E85D4A" strokeWidth="2" fill="none" data-id="element-2010" />
  </svg>;
const CarpetSteamIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-2011">
    <rect x="16" y="28" width="32" height="16" rx="2" fill="#1B1B2F" data-id="element-2012" />
    <rect x="20" y="20" width="24" height="8" rx="2" fill="#2BBCB3" data-id="element-2013" />
    <path d="M24 44 L40 44 L44 52 L20 52 Z" fill="#E8F6F5" data-id="element-2014" />
    <path d="M24 52 Q32 58 40 52" stroke="#F5C842" strokeWidth="2" fill="none" data-id="element-2015" />
    <circle cx="32" cy="36" r="4" fill="#F5C842" data-id="element-2016" />
  </svg>;
const AreaRugsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-2017">
    <path d="M16 20 C16 16 24 16 24 20 L24 44 C24 48 16 48 16 44 Z" fill="#2BBCB3" data-id="element-2018" />
    <path d="M24 20 L48 32 L48 52 L24 44 Z" fill="#1B1B2F" data-id="element-2019" />
    <path d="M24 24 L44 34 M24 32 L44 42" stroke="#E8F6F5" strokeWidth="2" data-id="element-2020" />
    <circle cx="20" cy="20" r="2" fill="#F5C842" data-id="element-2021" />
  </svg>;
export function PostRenovationForm() {
  // Step 3 State
  const [propertyType, setPropertyType] = useState('Cottage/Townhouse/Bungalow');
  const [kitchens, setKitchens] = useState('1 Kitchen');
  const [floors, setFloors] = useState(1);
  const [parking, setParking] = useState('Free on street');
  // Step 4 State (Extras)
  const [selectedExtras, setSelectedExtras] = useState<string[]>([]);
  const toggleExtra = (id: string) => {
    setSelectedExtras(prev => prev.includes(id) ? prev.filter(e => e !== id) : [...prev, id]);
  };
  const extrasList = [{
    id: 'airbnb',
    label: 'Airbnb Combo Package',
    icon: AirbnbComboIcon
  }, {
    id: 'dishwasher',
    label: 'Washing dishes',
    icon: DishwasherIcon
  }, {
    id: 'laundry',
    label: 'Laundry (wash & fold)',
    icon: LaundryIcon
  }, {
    id: 'oven',
    label: 'Inside of oven',
    icon: OvenIcon
  }, {
    id: 'fridge',
    label: 'Inside of fridge',
    icon: FridgeIcon
  }, {
    id: 'facade',
    label: 'Inside facade of windows',
    icon: FacadeWindowsIcon
  }, {
    id: 'microwave',
    label: 'Inside microwave',
    icon: MicrowaveIcon
  }, {
    id: 'cabinets',
    label: 'Interior of Kitchen Cabinets',
    icon: CabinetsIcon
  }, {
    id: 'basement',
    label: 'Finished Basement',
    icon: BasementIcon
  }, {
    id: 'flu',
    label: 'Flu Buster - Eucalyptus',
    icon: FluBusterIcon
  }, {
    id: 'sheets',
    label: 'Change Sheets',
    icon: SheetsIcon
  }, {
    id: 'property',
    label: 'Property Cleanup',
    icon: PropertyCleanupIcon
  }, {
    id: 'patio',
    label: 'Patio or Balcony',
    icon: PatioIcon
  }, {
    id: 'carpet',
    label: 'Carpet Steam Clean - Entire Home',
    icon: CarpetSteamIcon
  }, {
    id: 'rugs',
    label: 'Area Rugs Steam Cleaning',
    icon: AreaRugsIcon
  }];
  // Step 6 State
  const [selectedDate, setSelectedDate] = useState('04/04');
  const [selectedTime, setSelectedTime] = useState('14:00');
  const dates = [{
    day: 'M',
    date: '30/03'
  }, {
    day: 'Tu',
    date: '31/03'
  }, {
    day: 'W',
    date: '01/04'
  }, {
    day: 'Th',
    date: '02/04'
  }, {
    day: 'F',
    date: '03/04'
  }, {
    day: 'Sa',
    date: '04/04'
  }, {
    day: 'Su',
    date: '05/04'
  }];
  // Step 7 State
  const [paymentMethod, setPaymentMethod] = useState('By Credit/Debit Card');
  const StepHeading = ({
    number,
    title,
    subtitle
  }: {
    number: string;
    title: string;
    subtitle?: string;
  }) => <div className="mb-8" data-id="element-2022">
      <div className="flex items-center gap-4 mb-2" data-id="element-2023">
        <div className="w-10 h-10 rounded-full bg-accent flex items-center justify-center text-white font-heading font-bold text-xl shadow-md shrink-0" data-id="element-2024">
          {number}
        </div>
        <h3 className="text-2xl md:text-3xl font-heading font-bold text-primary uppercase tracking-wide" data-id="element-2025">
          {title}
        </h3>
      </div>
      {subtitle && <p className="text-gray-500 text-base ml-14 pb-4 border-b border-gray-100" data-id="element-2026">
          {subtitle}
        </p>}
      {!subtitle && <div className="ml-14 pb-4 border-b border-gray-100" data-id="element-2027"></div>}
    </div>;
  return <main className="min-h-screen bg-light pb-24" data-id="element-2028">
      <SEOHead title="Book Post Renovation Cleaning | Smith & Jengs" description="Specialised post-construction and renovation cleaning in Bicester. We remove all dust and debris so your space is move-in ready." data-id="element-2029" />
      {/* Dark Page Hero */}
      <section className="bg-primary pt-36 md:pt-44 pb-16 md:pb-24 relative overflow-hidden" data-id="element-2030">
        <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
        backgroundImage: 'radial-gradient(rgba(255,255,255,0.15) 1px, transparent 1px)',
        backgroundSize: '24px 24px'
      }} data-id="element-2031"></div>
        <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-2032">
          <div className="text-sm font-medium text-white/50 mb-6 uppercase tracking-wider" data-id="element-2033">
            <Link to="/" className="hover:text-accent transition-colors" data-id="element-2034">
              Home
            </Link>
            <span className="mx-2" data-id="element-2035">/</span>
            <Link to="/services" className="hover:text-accent transition-colors" data-id="element-2036">
              Our Services
            </Link>
            <span className="mx-2" data-id="element-2037">/</span>
            <span className="text-accent" data-id="element-2038">Book Online</span>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-2039">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-white uppercase leading-none tracking-tight mb-4" data-id="element-2040">
              Post Renovation
            </h1>
            <p className="text-xl md:text-2xl font-serif italic text-white/60" data-id="element-2041">
              Book Online in 60 Seconds
            </p>
          </motion.div>
        </div>
      </section>

      {/* Form & Sidebar Container */}
      <div className="container mx-auto px-6 md:px-12 -mt-8 relative z-20" data-id="element-2042">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start" data-id="element-2043">
          {/* Main Form Area */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-8 xl:col-span-9 bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-100" data-id="element-2044">
            <div className="text-center mb-16 flex flex-col items-center" data-id="element-2045">
              <div className="w-24 h-24 rounded-full border-2 border-accent/20 flex items-center justify-center mb-6 bg-accent/5" data-id="element-2046">
                <RenovationHeaderIcon data-id="element-2047" />
              </div>
              <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary uppercase tracking-wide mb-3" data-id="element-2048">
                Post Renovation Cleaning
              </h2>
              <p className="text-gray-500 text-lg max-w-2xl mx-auto" data-id="element-2049">
                Book your Post Renovation Cleaning in 60 seconds!
              </p>
              <span className="text-accent text-sm font-bold uppercase tracking-widest mt-4" data-id="element-2050">
                Post Renovation Cleaning
              </span>
            </div>

            <form className="space-y-20" onSubmit={e => e.preventDefault()} data-id="element-2051">
              {/* STEP 1 */}
              <section data-id="element-2052">
                <StepHeading number="1" title="Contact Information" data-id="element-2053" />
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 ml-0 md:ml-14" data-id="element-2054">
                  <input type="text" placeholder="First Name" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-2055" />
                  <input type="text" placeholder="Last Name" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-2056" />
                  <input type="email" placeholder="Email" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-2057" />
                  <div className="flex rounded-xl border border-gray-200 bg-gray-50 focus-within:bg-white focus-within:ring-2 focus-within:ring-accent focus-within:border-accent transition-all overflow-hidden" data-id="element-2058">
                    <div className="px-4 py-4 border-r border-gray-200 bg-gray-100 flex items-center justify-center text-gray-600 font-medium" data-id="element-2059">
                      🇬🇧 ▾
                    </div>
                    <input type="tel" placeholder="Phone Number" className="w-full px-5 py-4 outline-none bg-transparent text-primary" data-id="element-2060" />
                  </div>
                </div>
              </section>

              {/* STEP 2 */}
              <section data-id="element-2061">
                <StepHeading number="2" title="Cleaning Location" data-id="element-2062" />
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 ml-0 md:ml-14" data-id="element-2063">
                  <input type="text" placeholder="Enter a location" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-2064" />
                  <input type="text" placeholder="Unit/Apt/Suite #" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-2065" />
                  <input type="text" placeholder="City" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-2066" />
                  <input type="text" placeholder="Postal Code" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-2067" />
                </div>
                <div className="ml-0 md:ml-14 mt-4" data-id="element-2068">
                  <a href="#" className="text-accent hover:text-primary transition-colors flex items-center gap-2 font-medium" data-id="element-2069">
                    See what's included in our 'Post Renovation Cleaning'
                    service <Info size={16} data-id="element-2070" />
                  </a>
                </div>
              </section>

              {/* STEP 3 */}
              <section data-id="element-2071">
                <StepHeading number="3" title="Tell us about the cleaning" subtitle="All cleaning include cleaning the kitchen" data-id="element-2072" />
                <div className="space-y-8 ml-0 md:ml-14" data-id="element-2073">
                  <div data-id="element-2074">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-2075">
                      How many hours and cleaners would you like to book?
                    </label>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-2076">
                      <select className="w-full px-5 py-3.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-2077">
                        <option data-id="element-2078">2 Hours</option>
                        <option data-id="element-2079">3 Hours</option>
                        <option data-id="element-2080">4 Hours</option>
                        <option data-id="element-2081">5 Hours</option>
                        <option data-id="element-2082">6 Hours</option>
                        <option data-id="element-2083">7 Hours</option>
                        <option data-id="element-2084">8 Hours</option>
                      </select>
                      <select className="w-full px-5 py-3.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-2085">
                        <option data-id="element-2086">1 Cleaner</option>
                        <option selected data-id="element-2087">2 Cleaners</option>
                        <option data-id="element-2088">3 Cleaners</option>
                      </select>
                    </div>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-2089">
                    <label className="text-primary font-medium text-lg" data-id="element-2090">
                      Property type
                    </label>
                    <select className="w-full sm:w-64 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" value={propertyType} onChange={e => setPropertyType(e.target.value)} data-id="element-2091">
                      <option data-id="element-2092">Cottage/Townhouse/Bungalow</option>
                      <option data-id="element-2093">Semi-Detached</option>
                      <option data-id="element-2094">Detached</option>
                      <option data-id="element-2095">Flat/Apartment</option>
                      <option data-id="element-2096">Other</option>
                    </select>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-2097">
                    <label className="text-primary font-medium text-lg" data-id="element-2098">
                      Bedrooms
                    </label>
                    <select className="w-full sm:w-48 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-2099">
                      <option data-id="element-2100">Studio / 1 Bedroom</option>
                      <option data-id="element-2101">2 Bedrooms</option>
                      <option data-id="element-2102">3 Bedrooms</option>
                      <option data-id="element-2103">4 Bedrooms</option>
                      <option data-id="element-2104">5+ Bedrooms</option>
                    </select>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-2105">
                    <label className="text-primary font-medium text-lg" data-id="element-2106">
                      Bathrooms
                    </label>
                    <select className="w-full sm:w-48 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-2107">
                      <option data-id="element-2108">1 Bathroom</option>
                      <option data-id="element-2109">2 Bathrooms</option>
                      <option data-id="element-2110">3 Bathrooms</option>
                      <option data-id="element-2111">4+ Bathrooms</option>
                    </select>
                  </div>

                  <div data-id="element-2112">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-2113">
                      Kitchens
                    </label>
                    <div className="flex rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full max-w-md" data-id="element-2114">
                      {['1 Kitchen', '2 Kitchens', '3 Kitchens'].map(opt => <button key={opt} type="button" onClick={() => setKitchens(opt)} className={`flex-1 py-3.5 px-4 text-sm font-medium transition-all duration-300 ${kitchens === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-gray-200 last:border-r-0`} data-id="element-2115">
                          {opt}
                        </button>)}
                    </div>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-2116">
                    <label className="text-primary font-medium text-lg" data-id="element-2117">
                      # of floors in the home (incl. Basement)?
                    </label>
                    <div className="flex items-center shadow-sm rounded-xl overflow-hidden border border-gray-200" data-id="element-2118">
                      <button type="button" onClick={() => setFloors(Math.max(1, floors - 1))} className="w-12 h-12 bg-slate-500 text-white flex items-center justify-center text-xl font-bold hover:bg-slate-600 transition-colors" data-id="element-2119">
                        -
                      </button>
                      <div className="w-16 h-12 bg-white flex items-center justify-center font-medium text-lg" data-id="element-2120">
                        {floors}
                      </div>
                      <button type="button" onClick={() => setFloors(floors + 1)} className="w-12 h-12 bg-slate-500 text-white flex items-center justify-center text-xl font-bold hover:bg-slate-600 transition-colors" data-id="element-2121">
                        +
                      </button>
                    </div>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-2122">
                    <label className="text-primary font-medium text-lg" data-id="element-2123">
                      Total Square feet? (incl. Basement)
                    </label>
                    <select className="w-full sm:w-48 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-2124">
                      <option data-id="element-2125">less than 1600</option>
                      <option data-id="element-2126">1600-2500</option>
                      <option data-id="element-2127">2500-3500</option>
                      <option data-id="element-2128">3500+</option>
                    </select>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-2129">
                    <label className="text-primary font-medium text-lg" data-id="element-2130">
                      How do we access the premises?
                    </label>
                    <select className="w-full sm:w-64 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-2131">
                      <option data-id="element-2132">I will meet you at the location</option>
                      <option data-id="element-2133">Doorman</option>
                      <option data-id="element-2134">Lock box</option>
                      <option data-id="element-2135">Other</option>
                    </select>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-2136">
                    <label className="text-primary font-medium text-lg" data-id="element-2137">
                      Status of the home...
                    </label>
                    <select className="w-full sm:w-64 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-2138">
                      <option data-id="element-2139">Completely Empty</option>
                      <option data-id="element-2140">Partially Furnished</option>
                      <option data-id="element-2141">Fully Furnished</option>
                    </select>
                  </div>

                  <div data-id="element-2142">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-2143">
                      Parking
                    </label>
                    <div className="flex flex-wrap rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full" data-id="element-2144">
                      {['Free on street', 'Free home parking', 'Parking meters', 'Paid parking lot'].map(opt => <button key={opt} type="button" onClick={() => setParking(opt)} className={`flex-1 min-w-[140px] py-3.5 px-4 text-sm font-medium transition-all duration-300 ${parking === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-b sm:border-b-0 border-gray-200 last:border-r-0`} data-id="element-2145">
                          {opt}
                        </button>)}
                    </div>
                  </div>
                </div>
              </section>

              {/* STEP 4 */}
              <section data-id="element-2146">
                <StepHeading number="4" title="Extras?" subtitle="Free up more of your precious time for what matters most!" data-id="element-2147" />
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 ml-0 md:ml-14" data-id="element-2148">
                  {extrasList.map(({
                  id,
                  label,
                  icon: Icon
                }) => {
                  const isSelected = selectedExtras.includes(id);
                  return <button key={id} type="button" onClick={() => toggleExtra(id)} className={`flex flex-col items-center justify-center p-6 rounded-2xl border-2 transition-all duration-300 group ${isSelected ? 'border-accent bg-accent/5 shadow-md' : 'border-gray-100 bg-gray-50 hover:border-accent/30 hover:bg-gray-100'}`} data-id="element-2149">
                        <div className={`mb-4 transform transition-transform duration-300 ${isSelected ? 'scale-110' : 'group-hover:scale-105'}`} data-id="element-2150">
                          <Icon data-id="element-2151" />
                        </div>
                        <span className={`text-sm text-center font-medium ${isSelected ? 'text-primary font-bold' : 'text-gray-600'}`} data-id="element-2152">
                          {label}
                        </span>
                      </button>;
                })}
                </div>
              </section>

              {/* STEP 5 */}
              <section data-id="element-2153">
                <StepHeading number="5" title="Pick a date for the cleaning." subtitle="For recurring services, each one will commence on the same day and time as selected for the first service." data-id="element-2154" />
                <div className="ml-0 md:ml-14 space-y-8" data-id="element-2155">
                  <div className="flex flex-col items-center justify-center bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-2156">
                    <span className="font-bold text-primary mb-3" data-id="element-2157">
                      Choose a timezone
                    </span>
                    <div className="flex items-center gap-3" data-id="element-2158">
                      <span className="text-gray-500 text-sm" data-id="element-2159">
                        Our Company's
                      </span>
                      <div className="w-12 h-6 bg-accent rounded-full relative cursor-pointer" data-id="element-2160">
                        <div className="absolute right-1 top-1 w-4 h-4 bg-white rounded-full" data-id="element-2161"></div>
                      </div>
                      <span className="text-primary font-medium text-sm" data-id="element-2162">
                        Yours
                      </span>
                    </div>
                  </div>

                  <div className="border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-2163">
                    <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-gray-50" data-id="element-2164">
                      <button type="button" className="text-gray-400 hover:text-accent transition-colors" data-id="element-2165">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-2166">
                          <circle cx="12" cy="12" r="10" data-id="element-2167"></circle>
                          <polyline points="12 8 8 12 12 16" data-id="element-2168"></polyline>
                          <line x1="16" y1="12" x2="8" y2="12" data-id="element-2169"></line>
                        </svg>
                      </button>
                      <div className="flex gap-2 sm:gap-6 overflow-x-auto px-2 hide-scrollbar" data-id="element-2170">
                        {dates.map(d => <button key={d.date} type="button" onClick={() => setSelectedDate(d.date)} className={`flex flex-col items-center p-2 rounded-lg min-w-[60px] transition-colors ${selectedDate === d.date ? 'bg-accent/10 text-accent' : 'hover:bg-gray-100 text-gray-600'}`} data-id="element-2171">
                            <span className="text-sm font-medium mb-1" data-id="element-2172">
                              {d.day}
                            </span>
                            <span className="text-xs flex items-center gap-1" data-id="element-2173">
                              <Calendar size={12} data-id="element-2174" />
                              {d.date}
                            </span>
                          </button>)}
                      </div>
                      <button type="button" className="text-gray-400 hover:text-accent transition-colors" data-id="element-2175">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-2176">
                          <circle cx="12" cy="12" r="10" data-id="element-2177"></circle>
                          <polyline points="12 16 16 12 12 8" data-id="element-2178"></polyline>
                          <line x1="8" y1="12" x2="16" y2="12" data-id="element-2179"></line>
                        </svg>
                      </button>
                    </div>

                    <div className="p-6 bg-white flex flex-col items-end gap-3" data-id="element-2180">
                      {['14:00', '15:00'].map(time => <button key={time} type="button" onClick={() => setSelectedTime(time)} className={`flex items-center gap-2 px-6 py-2 rounded-full border transition-all ${selectedTime === time ? 'border-accent bg-accent text-white shadow-md' : 'border-gray-200 text-accent hover:border-accent hover:bg-accent/5'}`} data-id="element-2181">
                          <Clock size={16} data-id="element-2182" />
                          {time}
                        </button>)}
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm italic" data-id="element-2183">
                    For same day bookings, a Customer service agent will call
                    you.
                  </p>
                </div>
              </section>

              {/* STEP 6 */}
              <section data-id="element-2184">
                <StepHeading number="6" title="Access details & other info we should know?" subtitle="If your instructions to access the premise was either; 'Pick up Keys' or 'Lock Box', please include address for pick or the code to the lock box here." data-id="element-2185" />
                <div className="ml-0 md:ml-14" data-id="element-2186">
                  <textarea className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all min-h-[160px] text-primary resize-y" data-id="element-2187"></textarea>
                </div>
              </section>

              {/* STEP 7 */}
              <section data-id="element-2188">
                <StepHeading number="7" title="Payment details" subtitle="Select your method of payment. Credit Card charges may be pre-authorised, but applied only after the service event is complete." data-id="element-2189" />
                <div className="ml-0 md:ml-14 space-y-6" data-id="element-2190">
                  <div className="flex flex-wrap rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full" data-id="element-2191">
                    {['By Cash', 'By Check', 'By Credit/Debit Card', 'By Interac e-Transfer'].map(opt => <button key={opt} type="button" onClick={() => setPaymentMethod(opt)} className={`flex-1 min-w-[150px] py-4 px-4 text-sm font-medium transition-all duration-300 ${paymentMethod === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-b sm:border-b-0 border-gray-200 last:border-r-0`} data-id="element-2192">
                        {opt}
                      </button>)}
                  </div>

                  {paymentMethod === 'By Credit/Debit Card' && <motion.div initial={{
                  opacity: 0,
                  height: 0
                }} animate={{
                  opacity: 1,
                  height: 'auto'
                }} className="space-y-4" data-id="element-2193">
                      <input type="text" placeholder="name on credit card" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-2194" />

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-2195">
                        <button type="button" className="flex items-center gap-3 p-4 rounded-xl border-2 border-accent bg-accent/5 text-primary font-medium" data-id="element-2196">
                          <CreditCard className="text-accent" data-id="element-2197" /> Card
                        </button>
                        <button type="button" className="flex items-center gap-3 p-4 rounded-xl border border-gray-200 bg-white hover:bg-gray-50 text-primary font-medium transition-colors" data-id="element-2198">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-2199">
                            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#F5C842" data-id="element-2200" />
                            <path d="M15 10.5H9V13.5H15V10.5Z" fill="#1B1B2F" data-id="element-2201" />
                          </svg>
                          Google Pay
                        </button>
                      </div>

                      <div className="flex items-center gap-2 text-accent text-sm font-bold mt-2" data-id="element-2202">
                        <Lock size={14} data-id="element-2203" /> Secure, fast checkout with Link
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-2204">
                          <polyline points="6 9 12 15 18 9" data-id="element-2205"></polyline>
                        </svg>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-12 gap-4" data-id="element-2206">
                        <div className="sm:col-span-6 relative" data-id="element-2207">
                          <input type="text" placeholder="Card number" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-2208" />
                          <div className="absolute right-4 top-1/2 -translate-y-1/2 flex gap-1" data-id="element-2209">
                            <div className="w-8 h-5 bg-blue-800 rounded flex items-center justify-center text-[8px] text-white font-bold" data-id="element-2210">
                              VISA
                            </div>
                            <div className="w-8 h-5 bg-orange-500 rounded flex items-center justify-center text-[8px] text-white font-bold" data-id="element-2211">
                              MC
                            </div>
                          </div>
                        </div>
                        <input type="text" placeholder="Expiration date" className="sm:col-span-3 w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-2212" />
                        <input type="text" placeholder="Security code" className="sm:col-span-3 w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-2213" />
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-2214">
                        <select className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-2215">
                          <option data-id="element-2216">United Kingdom</option>
                          <option data-id="element-2217">United States</option>
                          <option data-id="element-2218">Canada</option>
                        </select>
                        <input type="text" placeholder="Postal Code" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-2219" />
                      </div>

                      <p className="text-xs text-gray-500 mt-4 leading-relaxed" data-id="element-2220">
                        By providing your card information, you allow Smith and
                        Jengs Cleaning Services to charge your card for future
                        payments in accordance with their terms.
                      </p>
                      <p className="text-xs text-gray-400 text-center italic mt-2" data-id="element-2221">
                        I authorise the operator to send instructions to the
                        financial institution that issued my card to take
                        payments from my card account in accordance with the
                        terms of my agreement with you.
                      </p>
                    </motion.div>}

                  <div className="space-y-3 pt-6 flex flex-col items-center" data-id="element-2222">
                    <label className="flex items-center gap-3 cursor-pointer group" data-id="element-2223">
                      <div className="w-5 h-5 rounded border border-gray-300 flex items-center justify-center group-hover:border-accent transition-colors" data-id="element-2224">
                        <div className="w-3 h-3 bg-transparent rounded-sm" data-id="element-2225"></div>
                      </div>
                      <span className="text-primary text-lg" data-id="element-2226">
                        I would like to be notified by email.
                      </span>
                    </label>
                  </div>
                </div>
              </section>

              {/* Submit */}
              <div className="pt-12 pb-4 flex justify-center border-t border-gray-100" data-id="element-2227">
                <button type="submit" className="bg-[#5CB85C] hover:bg-[#4cae4c] text-white px-16 py-4 rounded text-xl font-bold transition-all shadow-md hover:shadow-lg" data-id="element-2228">
                  Book Now
                </button>
              </div>
            </form>
          </motion.div>

          {/* Sidebar - Booking Summary */}
          <div className="lg:col-span-4 xl:col-span-3" data-id="element-2229">
            <div className="sticky top-32 bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-2230">
              <div className="bg-gray-50 p-6 border-b border-gray-100" data-id="element-2231">
                <h3 className="text-xl font-heading font-bold text-primary uppercase tracking-wide" data-id="element-2232">
                  Booking Summary
                </h3>
              </div>

              <div className="p-6 space-y-4 border-b border-gray-100" data-id="element-2233">
                <div className="flex items-center gap-3 text-gray-600 text-sm" data-id="element-2234">
                  <Calendar size={16} className="text-accent" data-id="element-2235" />
                  <span data-id="element-2236">4 Apr 2026</span>
                </div>
                <div className="flex items-center gap-3 text-gray-600 text-sm" data-id="element-2237">
                  <Clock size={16} className="text-accent" data-id="element-2238" />
                  <span data-id="element-2239">14:00</span>
                </div>
              </div>

              <div className="p-6 space-y-3 border-b border-gray-100 text-sm" data-id="element-2240">
                <div className="flex justify-between text-gray-600" data-id="element-2241">
                  <span data-id="element-2242">Post Renovation Cleaning</span>
                  <span data-id="element-2243">£75.00</span>
                </div>
                <div className="flex justify-between text-gray-600" data-id="element-2244">
                  <span data-id="element-2245">DISCOUNTS</span>
                  <span data-id="element-2246">£0.00</span>
                </div>
                <div className="flex justify-between text-gray-600" data-id="element-2247">
                  <span data-id="element-2248">EXTRAS</span>
                  <span data-id="element-2249">£0.00</span>
                </div>
              </div>
              <div className="p-6 bg-gray-50 flex justify-between items-center" data-id="element-2250">
                <span className="font-bold text-primary text-lg" data-id="element-2251">TOTAL</span>
                <span className="font-bold text-primary text-lg" data-id="element-2252">£75.00</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>;
}